import React from 'react'
import { motion } from 'framer-motion'
import './Card.css'
import { Link } from 'react-router-dom'

const cardVariants = {
    hidden: { opacity: 0, y: 16 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }
    },
    exit: {
        opacity: 0,
        y: -10,
        transition: { duration: 0.3 }
    }
}

const typeLabels = {
    restobar: 'Restaurant & Bar',
    residential: 'Residential',
    commercial: 'Office Space',
    hospitality: 'Hospitality',
    food_court: 'Food Court',
}

const Card = ({ details, filter }) => {
    return (
        <motion.div layout variants={cardVariants} className='master-card-container'>
            <Link
                to={`/projects/${details.id}`}
                state={{ projectId: details.id, fromFilter: filter }}
                className='project-link'
            >
                <div className='card-image-wrap'>
                    <motion.img
                        className='card-pic'
                        src={details.images[0]}
                        alt={details.projectName}
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
                    />
                    {/* Hover overlay with CTA */}
                    <motion.div
                        className='card-hover-overlay'
                        initial={{ opacity: 0 }}
                        whileHover={{ opacity: 1 }}
                        transition={{ duration: 0.2 }}
                    >
                        <span className='overlay-cta'>View Project →</span>
                    </motion.div>
                </div>

                {/* Always-visible info below image */}
                <div className='card-info'>
                    <span className='card-type'>{typeLabels[details.type] || details.type}</span>
                    <span className='card-name'>{details.projectName}</span>
                    <span className='card-location'>{details.location}</span>
                </div>
            </Link>
        </motion.div>
    )
}

export default Card
